<template>
  <div
    class="slider-indicators absolute mb-2 w-full justify-center flex"
    :class="position"
  >
    <div
      v-for="(slide, i) in slides"
      :key="slide"
      :data-index="i"
      class="
        indicator
        cursor-pointer
        p-0
        m-2
      "
      :class="slideSelected == i ? mode + ' selected' : mode"
      :style="{ 'box-shadow': '0px 2px 4px 0.5px black' }"
      @click="$emit('changePage',i)"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    slides: {
      type: [Object, Array],
      required: false,
      default: () => {}      
    },
    slideSelected: {
      type: [String, Number ],
      required: false,
      default: "0"
    },
    mode: {
      type: String,
      required: false,
      default: ""
    },
    position: {
      type: String,
      required: false,
      default: "bottom-0"
    }
  },
  emits: ['changePage']
};
</script>

<style scoped>
  .indicator {
    width: 30px;
    height: 3px;
  }
  
  .circulo  {
    border-radius: 100%  ;
    border: 2px solid rgba(255, 199, 0, 1);
    width: 10px;
    height: 10px;
  }

  .circulo.selected {
    background-color: rgba(255, 199, 0, 1);
  }
</style>